export const creatableUserTypes = [
    { role: 'PATIENT', value: 0, labelKey: 'users.typeOptions.patient' },
    { role: 'PATIENT_CARE_GIVER', value: 4, labelKey: 'users.typeOptions.patientCare' }
];

export const getCreatableUserType = (value) =>
    creatableUserTypes.find((type) => type.value === value);
export const sexOptions = ['FEMALE', 'MALE', 'NB_INTERSEX'];
export const genderOptions = [
    'WOMAN',
    'MAN',
    'TRANS_WOMAN',
    'TRANS_MAN',
    'NONBINARY',
    'AGENDER',
    'GENDERQUEER',
    'PREFER_NO_ANSWER',
    'NOT_LISTED'
];
